<!-- 获取车辆欠费记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo":  "粤A66666",
                "parkCodeList": ["2KNTYVWC"],
                "paybackStatus": 0,
                "arrearageTimeStart": "20171015000000",
                "arrearageTimeEnd": "20171015141333",
                "paybackTimeStart": "20171015000000",
                "paybackTimeEnd": "20171015141333",
                "pageNum": "1",
                "pageSize": "2"
            },
            responseCode: 	{
                "data": {
                    "currCount": 1,
                    "recordList": [

                    ],
                    "total": 600
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询车辆欠费记录信息",
                t_url: this.commonUrls.test+"getCarArrearageList",
                p_url: this.commonUrls.prod+"getCarArrearageList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: 'carNo、carNoList与parkingCodeList三选一', info3: 'String', info4: '车牌号码' },
                        { info1: 'carNoList', info2: 'carNo、carNoList与parkingCodeList三选一', info3: 'JSONArray', info4: '车牌号码列表' },
                        { info1: 'parkingCodeList', info2: 'carNo、carNoList与parkingCodeList三选一', info3: 'JSONArray', info4: '停车记录编号列表' },
                        { info1: 'parkCodeList', info2: '否', info3: 'String[]', info4: '停车场编号列表，不填时默认查询授权商所有停车场' },
                        { info1: 'paybackStatus', info2: '否', info3: 'Integer', info4: '补缴状态， 0 未补缴；1 已补缴，默认 0' },
                        { info1: 'arrearageTimeStart', info2: '否', info3: 'String', info4: '欠费起始时间，格式：yyyyMMddHHmmss' },
                        { info1: 'arrearageTimeEnd', info2: '否', info3: 'String', info4: '欠费结束时间，格式：yyyyMMddHHmmss' },
                        { info1: 'paybackTimeStart', info2: '否', info3: 'String', info4: '补缴起始时间，格式：yyyyMMddHHmmss' },
                        { info1: 'paybackTimeEnd', info2: '否', info3: 'String', info4: '补缴结束时间，格式：yyyyMMddHHmmss' },
                        { info1: 'isFullCarNoMatch', info2: '否', info3: 'Integer', info4: '是否车牌全匹配查询(0,1)，默认1全匹配' },

                        { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始，默认1' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多100条，默认10' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carNo', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'cardNo', info2: '否', info3: 'String', info4: '卡号' },
                        { info1: 'enterCarNo', info2: '是', info3: 'String', info4: '进场车牌号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'enterImageArray', info2: '否', info3: 'JSONArray', info4: '进场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'leaveCarNo', info2: '否', info3: 'String', info4: '离场车牌号' },
                        { info1: 'leaveTime', info2: '否', info3: 'String', info4: '离场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'leaveImageArray', info2: '否', info3: 'JSONArray', info4: '离场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'parkingFee', info2: '是', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'paidValue', info2: '是', info3: 'Decimal', info4: '已缴金额' },
                        { info1: 'paidReliefValue', info2: '是', info3: 'Decimal', info4: '已优惠金额' },
                        { info1: 'arrearValue', info2: '是', info3: 'Decimal', info4: '欠费金额' },
                        { info1: 'reliefValue', info2: '是', info3: 'Decimal', info4: '当前优惠金额' },
                        { info1: 'paybackValue', info2: '是', info3: 'Decimal', info4: '补缴金额' },
                        { info1: 'paybackStatus', info2: '是', info3: 'Integer', info4: '补缴状态，0 未补缴；1 已补缴' },
                        { info1: 'paybackTime', info2: '否', info3: 'String', info4: '补缴时间，格式：yyyyMMddHHmmss' },
                        { info1: 'collectorName', info2: '否', info3: 'String', info4: '收费员名称' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/record/getCarArrearageList.vue